"use client";
import { useState, useEffect, useId } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Listbox } from "@headlessui/react";

import IconArrow from "assets/svg/chevron_right_black.svg";

import { priceFormatter } from "@/src/helpers/number-formatter";

import Input from "../input";

import styles from "./styles.module.css";

const RangeSelectDropdown = ({ placeHolder, minList, maxList, buttonClass, listClass, onChange, type }) => {
  const dropdownClass = classNames({ [styles.dropdown]: true, [buttonClass]: buttonClass });
  const listWrapperClass = classNames({
    [styles.listwrapper]: true,
    [listClass]: listClass,
  });
  const [minValue, setMinValue] = useState({ value: "" });
  const [maxValue, setMaxValue] = useState({ value: "" });

  const id = useId();

  const handleMinInputChange = (event) => setMinValue({ value: priceFormatter(event.target.value) });

  const handleMaxInputChange = (event) => setMaxValue({ value: priceFormatter(event.target.value) });

  const handleMinChange = (min) => {
    setMinValue(min);
  };

  const handleMaxChange = (max) => {
    setMaxValue(max);
  };

  useEffect(() => {
    onChange && onChange(minValue, maxValue);
  }, [minValue, maxValue]);

  const getMinMaxText = (minValue, maxValue) => {
    if (!minValue && !maxValue) {
      return "";
    }
    if ((!minValue || minValue === "") && maxValue) {
      return `0 - ${maxValue} ${type}`;
    }
    if (minValue && (!maxValue || maxValue === "")) {
      return `${minValue} ve üzeri ${type}`;
    }
    return `${minValue} - ${maxValue} ${type}`;
  };

  return (
    <Listbox>
      <Listbox.Button className={dropdownClass}>
        <span className={styles.buttoncontent}>
          {minValue.value || maxValue.value ? (
            <span>{getMinMaxText(minValue?.value, maxValue?.value)}</span>
          ) : (
            <span className={styles.placeholder}>{placeHolder || "Seçiniz"}</span>
          )}
        </span>
        <span className={styles.icon}>
          <IconArrow />
        </span>
      </Listbox.Button>
      <Listbox.Options className={listWrapperClass}>
        <ul className={`${styles.list} ${styles.borderright}`}>
          <div className={styles.inputwrapper}>
            <span className={styles.inputtitle}>En az</span>
            <div className={styles.inputTypeWrapper}>
              <Input
                placeholder={"Giriniz"}
                inputClass={styles.input}
                value={minValue.value}
                onChange={handleMinInputChange}
              ></Input>
              {type && <div className={styles.inputType}>{type}</div>}
            </div>
          </div>
          {minList?.map((min, index) => (
            <div key={`${id}__${index}`}>
              {min.value !== null && (
                <li
                  key={`${id}-${index}`}
                  className={styles.option}
                  onClick={() => {
                    handleMinChange(min);
                  }}
                >
                  {`${min?.value} ${type || ""}`}
                </li>
              )}
            </div>
          ))}
        </ul>
        <ul className={styles.list}>
          <div className={styles.inputwrapper}>
            <span className={styles.inputtitle}>En çok</span>
            <div className={styles.inputTypeWrapper}>
              <Input
                placeholder={"Giriniz"}
                inputClass={styles.input}
                value={maxValue?.value}
                onChange={handleMaxInputChange}
              ></Input>
              {type && <div className={styles.inputType}>{type}</div>}
            </div>
          </div>
          {maxList?.map((max, index) => (
            <div key={`${id}_-${index}`}>
              {max.value !== null && (
                <li
                  key={`${id}+${index}`}
                  className={styles.option}
                  onClick={() => {
                    handleMaxChange(max);
                  }}
                >
                  {`${max?.value} ${type || ""}`}
                </li>
              )}
            </div>
          ))}
        </ul>
      </Listbox.Options>
    </Listbox>
  );
};

RangeSelectDropdown.propTypes = {
  placeHolder: PropTypes.any,
  minList: PropTypes.any,
  maxList: PropTypes.any,
  buttonClass: PropTypes.any,
  listClass: PropTypes.any,
  type: PropTypes.any,
  onChange: PropTypes.func,
};

export default RangeSelectDropdown;
